import { fontWeight } from '@pocketlaw/tetris';
import { css } from 'styled-components';
export const highlightStyles = css `
  background-color: unset;
  color: inherit;
  font-style: normal;
  ${fontWeight('semibold')};

  text-decoration: underline;
`;
export const wordBreak = css `
  /* "word-break: break-word" is deprecated but will probably still work */
  word-break: break-word;
  /* "overflow-wrap: anywhere" replaces "work-break: break-word" but is has poor browser support at the moment */
  overflow-wrap: anywhere;
`;
